export const formatLetterType = (type) => {
	let formattedType = "";

    switch(type) {
        case 'balancePayment':
            formattedType = "Balance Payment";
            break;
        case 'downPayment':
            formattedType = "Down Payment";
            break;
        case 'penaltyPayment':
            formattedType = "Penalty Payment";
            break;
        default:
            formattedType = type;
    }

	return formattedType;
}

export const formatLetterSubtype = (subtype) => {
	let formattedType = "";

    switch(subtype) {
        case 'firstLetter':
            formattedType = "1st Letter";
            break;
        case 'secondLetter':
            formattedType = "2nd Letter";
            break;
        case 'thirdLetter':
            formattedType = "3rd Letter";
            break;    
        default:
            formattedType = subtype;
    }

	return formattedType;
}